import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { app } from '../firebase.js';
import { getFirestore, collection, orderBy, query, getDocs, addDoc, Timestamp, doc, getDoc } from 'firebase/firestore';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function VehiclesComp() {
    const [vehiclesList, setVehiclesList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        vehicleType: '',
        vehicleMake: '',
        vehicleModel: '',
        vehicleReg: '',
        vehicleColor: '',
        vehicleEngineCC: '',
        vehiclePurchaseDate: ''
    });
    const [vehicleTypes, setVehicleTypes] = useState([]);

    const db = getFirestore(app);

    // Fetch vehicles
    useEffect(() => {
        const fetchVehicles = async () => {
            const q = query(collection(db, 'vehicles'), orderBy('signupdate', 'desc'));
            const querySnapshot = await getDocs(q);
            const vehicles = [];
            querySnapshot.forEach((doc) => {
                vehicles.push({ id: doc.id, ...doc.data() });
            });
            setVehiclesList(vehicles);
        };


        fetchVehicles();
    }, [db]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, 'vehicles'), {
                ...formData,
                signupdate: Timestamp.now()
            });
            setShowModal(false);
            setFormData({
                vehicleType: '',
                vehicleMake: '',
                vehicleModel: '',
                vehicleReg: '',
                vehicleColor: '',
                vehicleEngineCC: '',
                vehiclePurchaseDate: ''
            });
            // Refresh vehicles
            const q = query(collection(db, 'vehicles'), orderBy('signupdate', 'desc'));
            const querySnapshot = await getDocs(q);
            const vehicles = [];
            querySnapshot.forEach((doc) => {
                vehicles.push({ id: doc.id, ...doc.data() });
            });
            setVehiclesList(vehicles);
        } catch (error) {
            console.error('Error adding vehicle:', error);
        }
    };

    const viewCustomer = (id) => {
        console.log("View vehicle:", id);
    };

    const normalizedSearch = searchTerm.trim().toLowerCase();
    const filteredVehicles = vehiclesList.filter((vehicle) => {
        if (!normalizedSearch) return true;
        const values = [
            vehicle.vehicleType,
            vehicle.vehicleMake,
            vehicle.vehicleModel,
            vehicle.vehicleReg,
            vehicle.vehicleColor,
            vehicle.vehicleEngineCC,
            vehicle.vehiclePurchaseDate
        ];
        return values.some((value) =>
            String(value || '').toLowerCase().includes(normalizedSearch)
        );
    });

    return (
        <div className="dataComp">
            <div className="dataCompTop">
                <h5>All Vehicles</h5>
                <div className="searchContainer">
                    <FontAwesomeIcon icon={faSearch} className="searchIcon" />
                    <input
                        type="text"
                        placeholder="Type to search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button>Go</button>
                    <button onClick={() => setShowModal(true)}>Add a Vehicle</button>
                </div>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Vehicle Type</th>
                        <th>Vehicle Make</th>
                        <th>Vehicle Model</th>
                        <th>Registration</th>
                        <th>Vehicle Color</th>
                        <th>Engine Capacity</th>
                        <th>Purchase Date</th>
                        {/* <th>View</th> */}
                    </tr>
                </thead>
                <tbody>
                    {filteredVehicles.map((vehicle) => (
                        <tr key={vehicle.id}>
                            <td>{vehicle.vehicleType}</td>
                            <td>{vehicle.vehicleMake}</td>
                            <td>{vehicle.vehicleModel}</td>
                            <td>{vehicle.vehicleReg}</td>
                            <td>{vehicle.vehicleColor}</td>
                            <td>{vehicle.vehicleEngineCC} CC</td>
                            <td>{vehicle.vehiclePurchaseDate}</td>
                            {/* <td>
                                <button
                                    className="btn-sm btn btn-warning"
                                    onClick={() => viewCustomer(vehicle.id)}
                                >
                                    View Vehicle
                                </button>
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Add Vehicle Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Vehicle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>

                        <Form.Group className="mb-3">
                            <Form.Label>Vehicle Type</Form.Label>
                            <Form.Control
                                type="text"
                                name="vehicleType" 
                                value={formData.vehicleType}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Vehicle Make</Form.Label>
                            <Form.Control
                                type="text"
                                name="vehicleMake"
                                value={formData.vehicleMake}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Vehicle Model</Form.Label>
                            <Form.Control
                                type="text"
                                name="vehicleModel"
                                value={formData.vehicleModel}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Registration</Form.Label>
                            <Form.Control
                                type="text"
                                name="vehicleReg"
                                value={formData.vehicleReg}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Vehicle Color</Form.Label>
                            <Form.Control
                                type="text"
                                name="vehicleColor"
                                value={formData.vehicleColor}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Engine Capacity (CC)</Form.Label>
                            <Form.Control
                                type="number"
                                name="vehicleEngineCC"
                                value={formData.vehicleEngineCC}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Purchase Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="vehiclePurchaseDate"
                                value={formData.vehiclePurchaseDate}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Save Vehicle
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default VehiclesComp;
